import { CrewErrorBoundary } from 'components/functions/crewErrorBoundary'
import { FC, memo } from 'react'
import { TaskTemplateListToolbar } from './components/taskTemplateListToolbar/taskTemplateListToolbar'
import { TaskTemplateListGrid } from './components/taskTemplateListGrid/taskTemplateListGrid'

export const ProjectDetailManagementTaskTemplateList: FC = memo(() => {
  return (
    <div className="flex flex-col gap-2.5">
      <CrewErrorBoundary>
        <TaskTemplateListToolbar />
      </CrewErrorBoundary>

      <CrewErrorBoundary>
        <TaskTemplateListGrid />
      </CrewErrorBoundary>
    </div>
  )
})
